import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { guestToken, resetPassword } from "../../redux/auth/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { useForm } from "react-hook-form";
import storePersist from "../../redux/storePersist";
import errorHandler from "../../request/errorHandler";
import { toast } from "react-toastify";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import { RotatingLines } from "react-loader-spinner";

export default function ResetPassword() {
	const navigate = useNavigate()
	const dispatch = useAppDispatch()
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const { height, width } = useWindowDimensions();
	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();

	const [steps, setSteps] = useState<any>({})


	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e.target.value })
	}

	useEffect(() => {
		const guest = localStorage.getItem('guest-token')
		if (!guest) {
			dispatch(guestToken())
		}
		clearErrors('NewPassword')
		clearErrors('Email')
		clearErrors('confirmPassword')
		clearErrors('OTP')
	}, [])


	const onFinish = async () => {
		await setIsLoading(true)
		if (steps?.NewPassword === steps?.confirmPassword) {
			await dispatch(resetPassword({
				loginData:
				{
					"Records": [
						{
							"Email": steps?.Email,
							"PhoneNumber": null,
							"NewPassword": steps?.NewPassword,
							"OTP": steps.otp
						}
					]
				}
			}))
			await setIsLoading(false)
		} else {
			await setIsLoading(false)
			toast.error(
				'NewPassword and Confirm Password must be same',
			);
		}
		const activeUser = storePersist.get('reset-pwd')
		switch (activeUser) {
			case 'transporter':
				navigate('/auth/login/transporter');
				break;
			case 'transport-agent':
				navigate('/auth/login/transport-agent');
				break;
			case 'management':
				navigate('/');
				break;
			case 'customer':
				navigate('/auth/login/customer');
				break;
		}


	};
	const back = () => {
		navigate('/')
	}

	const banner = require(`./../../assets/img/banner3 copy.png`)
	const logo = require(`./../../assets/img/digiit.ai.png`)
	return (
		<>
			<form onSubmit={handleSubmit(onFinish)} >
				{(width && width < 724) ?
					<div className="w-screen h-screen  px-6  ">
						<div className="flex flex-col items-end justify-around h-full">
							<div className="flex flex-col justify-center w-full h-max px-4 shadow py-3 ">


								<div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">
									Reset Password
									<svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
								</div>
								<div className="w-full my-5">
									<label
										className="block text-sm font-light mb-2" >
										Email Address *
									</label>
									<input
										type="text"
										{...register('Email', {
											required: true,
											pattern:
												/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
										})}
										className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="Email"
										onChange={(e) => handleSteps(e, 'Email')}
									/>
									{errors.Email && errors.Email.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.Email && errors.Email.type === "pattern" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
									)}

								</div>
								<div className="w-full my-5">
									<label
										className="block  text-black text-sm font-light mb-2"
									>
										New Password *
									</label>
									<input
										type="password"
										{...register('NewPassword', { required: true, maxLength: 15 })}
										className="border-0 px-3 py-3  text-indigo-600    rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="New Password"
										onChange={(e) => handleSteps(e, 'NewPassword')}
									/>
									{errors.NewPassword && errors.NewPassword.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.NewPassword && errors.NewPassword.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>
								<div className="w-full my-5">
									<label
										className="block  text-black text-sm font-light mb-2"
									>
										Confirm Password *
									</label>
									<input
										type="password"
										{...register('confirmPassword', { required: true, maxLength: 15 })}
										className="border-0 px-3 py-3  text-indigo-600    rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="confirm Password"
										onChange={(e) => handleSteps(e, 'confirmPassword')}
									/>
									{errors.confirmPassword && errors.confirmPassword.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.confirmPassword && errors.confirmPassword.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>

								<div className="w-full my-5">
									<label
										className="block  text-black text-sm font-light mb-2"
									>
										OTP *
									</label>
									<input
										className="text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 d"
										type="number"
										placeholder="OTP"
										{...register('otp', {
											required: `OTP is required`,
										})}
										onChange={(e) => {
											handleSteps(e, 'otp');
										}}
									/>
								</div>

								<div className="text-center mt-6">
									<button type="submit"
										disabled={isLoading}
										className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
											} flex-row flex items-center justify-center  text-light rounded font-semibold  text-xl p-4 w-full h-12`}

									>Reset Password
										<div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
											<RotatingLines
												visible={true}
												width={'20'}
												strokeColor="#fff"
												strokeWidth="6"
												animationDuration="0.75"
												ariaLabel="rotating-lines-loading"
											/>
										</div>
									</button>
								</div>
							</div>
						</div>


					</div>

					:

					<div className="flex min-h-screen w-screen overflow-hidden">
						{/* Left Side - Image */}
						<div className="w-1/2 hidden md:block">
							<img
								src={banner}
								alt="IIMB Building"
								className="w-full h-full object-cover"
							/>
						</div>

						{/* Right Side - Form */}
						<div className="w-full md:w-1/2 flex justify-center items-center bg-white">
							<div className="max-w-md w-full px-6 sm:px-8">
								{/* Logo */}
								<div className="flex justify-center mb-6">
									<img
										src={logo}
										alt="Digiit Logo"
										className="h-10"
									/>
								</div>

								{/* Heading */}
								<h2 className="text-2xl font-semibold text-center mb-6">
									Reset Password
								</h2>

								<div className="w-full my-5">
									<label
										className="block text-sm font-light mb-2" >
										Email Address *
									</label>
									<input
										type="text"
										{...register('Email', {
											required: true,
											pattern:
												/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
										})}
										className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="Email"
										onChange={(e) => handleSteps(e, 'Email')}
									/>
									{errors.Email && errors.Email.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.Email && errors.Email.type === "pattern" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
									)}

								</div>
								<div className="w-full my-5">
									<label
										className="block  text-black text-sm font-light mb-2"
									>
										New Password *
									</label>
									<input
										type="password"
										{...register('NewPassword', { required: true, maxLength: 15 })}
										className="border-0 px-3 py-3  text-indigo-600    rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="New Password"
										onChange={(e) => handleSteps(e, 'NewPassword')}
									/>
									{errors.NewPassword && errors.NewPassword.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.NewPassword && errors.NewPassword.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>
								<div className="w-full my-5">
									<label
										className="block  text-black text-sm font-light mb-2"
									>
										Confirm Password *
									</label>
									<input
										type="password"
										{...register('confirmPassword', { required: true, maxLength: 15 })}
										className="border-0 px-3 py-3  text-indigo-600    rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="confirm Password"
										onChange={(e) => handleSteps(e, 'confirmPassword')}
									/>
									{errors.confirmPassword && errors.confirmPassword.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.confirmPassword && errors.confirmPassword.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>

								<div className="w-full my-5">
									<label
										className="block  text-black text-sm font-light mb-2"
									>
										OTP *
									</label>
									<input
										className="text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 d"
										type="number"
										placeholder="OTP"
										{...register('otp', {
											required: `OTP is required`,
										})}
										onChange={(e) => {
											handleSteps(e, 'otp');
										}}
									/>
								</div>

								{/* Links */}
								<div className="flex flex-col mt-2 text-sm space-y-2">
									<a
										href=""
										onClick={back}
										className="text-blue-600 hover:underline self-start"
									>
										Back to Login
									</a>
								</div>

								{/* Submit */}

								<button
									type="submit"
									disabled={isLoading}
									className={`${isLoading ? 'bg-blue-600 bg-opacity-70' : 'bg-blue-600'
										}  flex-row mt-6 flex items-center justify-center text-white rounded font-semibold text-xl p-4 w-full h-11`}
								>
									Reset Password
									<div className={` ${isLoading ? 'visible pl-2' : 'invisible'}`}>
										<RotatingLines
											visible={true}
											width={'20'}
											strokeColor="#fff"
											strokeWidth="6"
											animationDuration="0.75"
											ariaLabel="rotating-lines-loading"
										/>
									</div>
								</button>





								{/* Terms */}
								<div className="mt-4 text-xs text-center text-gray-500">
									<p>Terms of use - Privacy policy</p>
									<p className="mt-1">
										This site is protected by Digiit Business Services{" "}
										<a href="https://policies.google.com/privacy" className="underline">
											Privacy Policy
										</a>{" "}
										and{" "}
										<a href="https://policies.google.com/terms" className="underline">
											Terms of Service
										</a>{" "}
										apply.
									</p>
								</div>
							</div>
						</div>
					</div>}
			</form >
		</>
	);
}
